import {
  Home, Building2, Briefcase, Store, PackageOpen, Truck,
  Wrench, MapPin, Warehouse, Users, ShieldCheck, Clock,
  BadgeIndianRupee, HardHat, PackageCheck,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "house-shifting",
    title: "House Shifting",
    desc: "Door-to-door relocation for villas, independent homes and large families with full care.",
    Icon: Home,
  },
  {
    slug: "apartment-shifting",
    title: "Apartment Shifting",
    desc: "High-rise specialists. We handle lifts, narrow staircases, and society protocols.",
    Icon: Building2,
  },
  {
    slug: "office-relocation",
    title: "Office Relocation",
    desc: "Zero-downtime planning for corporate moves with weekend execution available.",
    Icon: Briefcase,
  },
  {
    slug: "commercial-shifting",
    title: "Commercial Shifting",
    desc: "Showrooms, restaurants and retail outlets relocated with inventory tracking.",
    Icon: Store,
  },
  {
    slug: "packing-unpacking",
    title: "Packing & Unpacking",
    desc: "Multi-layer protection: bubble wrap, foam, corrugated sheets and wooden crates.",
    Icon: PackageOpen,
  },
  {
    slug: "loading-unloading",
    title: "Loading & Unloading",
    desc: "Trained labour with mechanical hoists for heavy furniture and appliances.",
    Icon: Truck,
  },
  {
    slug: "dismantling-reassembly",
    title: "Furniture Dismantling & Reassembly",
    desc: "Modular wardrobes, beds, and workstations dismantled and rebuilt at destination.",
    Icon: Wrench,
  },
  {
    slug: "interstate-relocation",
    title: "Interstate Relocation",
    desc: "GPS-tracked vehicles across India with insurance and real-time updates.",
    Icon: MapPin,
  },
  {
    slug: "warehouse-shifting",
    title: "Warehouse Shifting",
    desc: "Bulk inventory, racking systems, and equipment relocation by trained crew.",
    Icon: Warehouse,
  },
];

export const WHY_CHOOSE_US = [
  { title: "Experienced Team", desc: "12+ years of relocation expertise across Kerala.", Icon: Users },
  { title: "Safe Packing", desc: "Premium materials, bubble wrap, custom wooden crates.", Icon: ShieldCheck },
  { title: "On-Time Delivery", desc: "Strict timelines. We respect your moving day.", Icon: Clock },
  { title: "Transparent Pricing", desc: "No hidden costs. Detailed quote, fixed price.", Icon: BadgeIndianRupee },
  { title: "Professional Labour", desc: "Uniformed, background-verified, trained crew.", Icon: HardHat },
  { title: "Secure Transportation", desc: "Closed-body trucks, GPS tracking, full insurance.", Icon: PackageCheck },
];

export const PROCESS_STEPS = [
  { step: 1, title: "Enquiry", desc: "Call, WhatsApp or fill the form." },
  { step: 2, title: "Site Visit", desc: "Free inventory assessment at your home." },
  { step: 3, title: "Quotation", desc: "Detailed transparent pricing within 2 hours." },
  { step: 4, title: "Booking", desc: "Confirm with a small advance to lock the date." },
  { step: 5, title: "Packing", desc: "Multi-layer packing with quality materials." },
  { step: 6, title: "Loading", desc: "Careful loading by trained professionals." },
  { step: 7, title: "Transportation", desc: "GPS-tracked safe transit to destination." },
  { step: 8, title: "Delivery", desc: "Unloading, unpacking and reassembly." },
];

export const SERVICE_AREA_TIERS = [
  {
    tier: "Tier 1",
    label: "Highest Demand",
    areas: ["Kakkanad", "Vazhakkala", "Thrikkakara", "Edapally", "Vyttila", "Kaloor"],
  },
  {
    tier: "Tier 2",
    label: "Strong Demand",
    areas: ["Tripunithura", "Aluva", "Panampilly Nagar", "Vennala", "Elamkulam"],
  },
  {
    tier: "Tier 3",
    label: "Growing Demand",
    areas: ["Palarivattom", "Kalamassery", "Maradu", "Eroor", "Thevara", "Kadavanthra", "Mundamveli", "Fort Kochi", "Cheranalloor"],
  },
  {
    tier: "Tier 4",
    label: "Secondary Growth",
    areas: ["Thammanam", "Kizhakkambalam", "Chottanikkara", "Pallikkara", "Thiruvankulam", "Puthencruz", "Mulanthuruthy", "Piravom Road Belt"],
  },
  {
    tier: "Tier 5",
    label: "Untapped / Outskirts",
    areas: ["Nedumbassery", "Angamaly", "Perumbavoor Road Belt", "North Paravur", "Vypin Island", "Mulavukad", "Vallarpadam", "Njarakkal", "Kumbalangi", "Chendamangalam", "Manjapra", "Keezhmad"],
  },
  {
    tier: "Tier 6",
    label: "Deep Suburbs & Panchayat Towns",
    areas: ["Varappuzha", "Vadakkekara", "Chittattukara", "Ezhikkara", "Kottuvally", "Puthenvelikkara", "Kunnukara", "Kadungalloor", "Karumalloor", "Alangad", "Chengamanad", "Edathala", "Kanjoor", "Sreemoolanagaram", "Choornikkara", "Mookkannur", "Thuravoor", "Ayyampuzha", "Karukutty", "Malayattoor", "Neeleswaram", "Parakkadavu", "Kalady", "Asamannoor", "Koovappady", "Mudakkuzha", "Okkal", "Rayamangalam", "Vengola", "Vengoor", "Chellanam", "Edavanakkad", "Kuzhuppilly", "Pallippuram", "Nayarambalam"],
  },
  {
    tier: "Tier 7",
    label: "Remote / Outermost Ernakulam",
    areas: ["Vazhakkulam", "Muvattupuzha", "Kothamangalam", "Piravom", "Kanjiramattom", "Koothattukulam"],
  },
];

export const SERVICE_AREAS_TOP20 = [
  "Kakkanad", "Panampilly Nagar", "Marine Drive", "Edappally", "Willingdon Island",
  "Fort Kochi", "Thevara", "Aluva", "Tripunithura",
  "Vazhakkala", "Thrikkakara", "Vyttila", "Kaloor",
  "Palarivattom", "Kalamassery", "Vennala", "Maradu",
  "Angamaly", "Nedumbassery", "Chottanikkara",
];

export const SERVICE_AREAS = SERVICE_AREA_TIERS.flatMap((t) => t.areas);

export const TESTIMONIALS = [
  {
    name: "Anjali Menon",
    location: "Edappally, Kochi",
    rating: 5,
    text: "Moved our 3BHK from Edappally to Kakkanad. Zero damage, on-time, polite crew. Worth every rupee.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Rajeev Krishnan",
    location: "Aluva",
    rating: 5,
    text: "Office relocation done over a weekend without business disruption. Highly professional team.",
    avatar: "https://images.unsplash.com/photo-1566753323558-f4e0952af115?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
  {
    name: "Priya Thomas",
    location: "Thrippunithura",
    rating: 5,
    text: "They packed even the smallest items with such care. Reassembled wardrobes perfectly at new home.",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Sajeev Pillai",
    location: "Kakkanad",
    rating: 5,
    text: "Interstate move to Bangalore. GPS tracking gave peace of mind. Items arrived exactly as packed.",
    avatar: "https://images.unsplash.com/photo-1504199367641-aba8151af406?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
  {
    name: "Lakshmi Nair",
    location: "Angamaly",
    rating: 5,
    text: "Transparent quote with no surprise charges. The crew was punctual and respectful throughout.",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80",
  },
  {
    name: "Arun Varghese",
    location: "Muvattupuzha",
    rating: 5,
    text: "Shifted our shop inventory overnight. They handled fragile items like their own. Recommended.",
    avatar: "https://images.unsplash.com/photo-1562337404-3044c84ac061?crop=entropy&cs=srgb&fm=jpg&w=200&q=85",
  },
];

export const FAQS = [
  {
    q: "How much does packers and movers cost in Kochi?",
    a: "Local shifting within Kochi typically ranges from ₹3,500 to ₹15,000 for 1BHK–3BHK homes, depending on volume, floor and distance. We provide a free site visit and a transparent itemized quote with no hidden charges.",
  },
  {
    q: "Do you offer free quotations?",
    a: "Yes. We offer free on-site inventory assessment within Ernakulam and a detailed written quotation within 2 hours. You can also request a quick estimate over WhatsApp by sharing photos.",
  },
  {
    q: "Is my furniture insured during the move?",
    a: "Yes. All shipments are eligible for transit insurance. Local moves include basic damage protection; for high-value items and interstate moves we recommend full-value insurance which we arrange on request.",
  },
  {
    q: "Do you pack and unpack at the new location?",
    a: "Absolutely. Our full-service package includes professional packing at origin, careful loading, transportation, unloading, unpacking, and reassembly of modular furniture at the destination.",
  },
  {
    q: "How early should I book?",
    a: "We recommend booking at least 3–5 days in advance. For weekend or month-end moves, book 7–10 days ahead. Last-minute bookings are accommodated based on crew availability.",
  },
  {
    q: "What areas do you cover?",
    a: "We serve all of Kochi including Ernakulam, Kakkanad, Aluva, Edappally, Thrippunithura, Angamaly, Perumbavoor, Muvattupuzha and across Kerala. Interstate relocation pan-India is also available.",
  },
  {
    q: "Do you handle apartment moves with lift restrictions?",
    a: "Yes. We coordinate with society managers, schedule lift bookings, and use rope-pulley systems where lifts are restricted. Our crew is experienced with high-rise apartments in Kochi.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept UPI, bank transfer, debit/credit cards, and cash. A small advance is collected at booking; the balance is paid on delivery after you verify the inventory.",
  },
];

export const GALLERY = [
  { type: "video", category: "Loading", url: "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/4cp2m9eo_WhatsApp%20Video%202026-06-19%20at%204.39.29%20PM.mp4", poster: "/gallery/img1.jpeg", alt: "Move On crew on a shifting job" },
  { category: "Loading", url: "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/48jndenj_WhatsApp%20Image%202026-06-14%20at%204.54.37%20PM.jpeg", alt: "Move On truck loaded with household items" },
  { category: "Packing", url: "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/hojvx87k_WhatsApp%20Image%202026-06-14%20at%204.54.37%20PM%20%283%29.jpeg", alt: "Our team packing kitchen items carefully" },
  { category: "Before & After", url: "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/lkdle272_WhatsApp%20Image%202026-06-14%20at%204.54.37%20PM%20%282%29.jpeg", alt: "Household goods organized before packing" },
  { category: "Loading", url: "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/ixckxek5_WhatsApp%20Image%202026-04-14%20at%201.40.42%20PM.jpeg", alt: "Furniture and wardrobes ready for loading" },
  { category: "Packing", url: "/gallery/img1.jpeg", alt: "On-site packing work" },
  { category: "Packing", url: "/gallery/img2.jpeg", alt: "Crew handling fragile items" },
  { category: "Loading", url: "/gallery/img3.jpeg", alt: "Loading furniture into truck" },
  { category: "Before & After", url: "/gallery/img4.jpeg", alt: "Completed move setup" },
];

export const GALLERY_CATEGORIES = ["All", "Packing", "Loading", "Before & After"];

